import { exceptionCode } from '../util/errnoException';
import type { OpenFile, Vfs } from '../types/vfs';
import { recursiveMkdir } from './recursiveFs';

/**
 * Returns false if there is already a file with the given
 * name. Otherwise, creates it with the provided content, if any,
 * and returns true.
 */
export async function tryWriteNewFileAt(vfs: Vfs, filePath: string, content?: Uint8Array): Promise<boolean> {
  const sep = filePath.lastIndexOf('/');
  if (sep != -1) {
    const dirPath = filePath.substring(0, sep);
    await recursiveMkdir(vfs, dirPath);
  }

  let file: OpenFile;
  try {
    file = await vfs.open(filePath, 'wx');
  } catch (ex) {
    if (exceptionCode(ex) === 'EEXIST') {
      return false;
    }
    throw ex;
  }
  if (content) {
    await writeFileContent(file, content);
  }
  await file.close();
  return true;
}

export async function writeFileContent(file: OpenFile, content: Uint8Array, offset: number = 0) {
  const length = content.byteLength;
  let pos = 0;
  while (pos < length) {
    const written = await file.write(content, pos, length - pos, pos + offset);
    pos += written;
  }
}

export async function atomicWriteWholeFile(vfs: Vfs, filePath: string, content: Uint8Array) {
  const partPath = filePath + '.part';
  const of = await vfs.open(partPath, 'w');
  await writeFileContent(of, content);
  await of.close();
  await vfs.rename(partPath, filePath);
}

export async function writeStringToFile(vfs: Vfs, filePath: string, content: string) {
  const textEncoder = new TextEncoder();
  const buffer = textEncoder.encode(content);
  await atomicWriteWholeFile(vfs, filePath, buffer);
}


export async function writeFile(vfs: Vfs, filePath: string, content: Uint8Array) {
  const of = await vfs.open(filePath, 'w');
  await writeFileContent(of, content);
  await of.close();
}
